// libs
import React from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import ValidityText from 'shared/layouts/Coupons/CouponsExpiry/CouponValdity/CouponValidity';
import CouponDeltaCommunication from 'shared/layouts/Coupons/components/DeltaCommunication/DeltaCommunication';

// context
import { useLoaderContext } from 'shared/components/LoaderProvider/context';

// svgs
import CircleCrossWhite from '@nykaa/ui-components/Icons/circle-x-duotone';
import ArrowLeft from '@nykaa/ui-components/Icons/arrow-left';

// styles
import {
  ViewDetailsContainer,
  CloseIcon,
  Header,
  OverlaySheet,
  CouponInfo,
  OfferTitle,
  Subtitle,
  ActionContainer,
  ActionButtonOffer,
  BottomContainer,
  InfoContainer,
  DiscountTagWrapper,
  SaveUptoText,
} from './styles';

// constants
import { TEXTS } from 'shared/layouts/Coupons/constants';
import { LOGO_TYPE } from 'shared/constants';

// types
import { OfferDetails } from 'shared/layouts/Coupons/types';
import Logo from 'shared/components/Logo';

// defs
interface ViewDetailsNudgeProps {
  onHide: () => void;
  offerDetails: OfferDetails;
  className?: string;
  sheetTransition?: SHEET_TRANSITION;
  actionContainerText?: string;
  showBackButton?: boolean;
  showOverlay?: boolean;
  isEligibleForDeltaCommunication?: boolean;
}

function ViewDetailsNudge({
  onHide,
  offerDetails,
  className = '',
  sheetTransition = SHEET_TRANSITION.BOTTOM,
  actionContainerText = TEXTS.OKAY,
  showBackButton = false,
  showOverlay = true,
  isEligibleForDeltaCommunication,
}: ViewDetailsNudgeProps) {
  const { showLoader, hideLoader } = useLoaderContext();

  if (isEmpty(offerDetails)) {
    showLoader({});
  } else hideLoader();

  const {
    title,
    description,
    label = '',
    offerDiscount = '',
    expiryEpoch = 0,
    deltaTextModified = '',
    status,
    offerId,
  } = offerDetails;
  return (
    <OverlaySheet
      onHide={onHide}
      disableNav
      transitionFrom={sheetTransition}
      hideOnOverlayClick
      className={className}
      showOverlay={showOverlay}
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <ViewDetailsContainer className="view-details-container">
            <Header showBottomBorder>
              {showBackButton ? (
                <SaveUptoText>
                  <CloseIcon onClick={doHide}>
                    <ArrowLeft />{' '}
                  </CloseIcon>
                  {label ? label : `${TEXTS.SAVE_OFFER} ${offerDiscount}`}
                </SaveUptoText>
              ) : (
                <CloseIcon onClick={doHide}>
                  <CircleCrossWhite />
                </CloseIcon>
              )}
            </Header>
            <InfoContainer className="offer-info">
              <CouponInfo>
                <DiscountTagWrapper>
                  <Logo type={LOGO_TYPE.OFFERS} />
                </DiscountTagWrapper>
                <OfferTitle className="title">{title}</OfferTitle>
                <Subtitle className="subtitle">{description}</Subtitle>
                {expiryEpoch > 0 && <ValidityText expiryEpoch={expiryEpoch} />}
                {isEligibleForDeltaCommunication && (
                  <CouponDeltaCommunication
                    deltaModifiedText={deltaTextModified}
                    isDetailsView
                    isOffer={true}
                    status={status}
                    offerId={offerId}
                    couponData={offerDetails}
                    isPDP
                  />
                )}
              </CouponInfo>
            </InfoContainer>

            <BottomContainer showTopBorder={false}>
              <ActionContainer>
                <ActionButtonOffer
                  kind={'secondary'}
                  size={'large'}
                  shape={'default'}
                  onClick={doHide}
                >
                  {actionContainerText}
                </ActionButtonOffer>
              </ActionContainer>
            </BottomContainer>
          </ViewDetailsContainer>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}

export default ViewDetailsNudge;
